const CUSTOM_INDEX = [
  {
    id: "17",
    type: "serie",
    apply: "priceVariants",
    file: "serie_17_priceVariants",
  },
  {
    id: "17",
    type: "serie-classes",
    apply: "priceVariants",
    file: "serie_17_priceVariants_classes",
  },
  {
    id: "20",
    type: "serie",
    apply: "freeContent",
    file: "serie_20_freeContent",
  },
  {
    id: "23",
    type: "serie",
    apply: "priceVariants",
    file: "serie_23_priceVariants",
  },
];

export default CUSTOM_INDEX;
